module.exports = __webpack_public_path__ + "img/trading2.2ca97aa9.svg";